module.exports = __webpack_public_path__ + "img/3.d1f11b4c.png";